import React from 'react';
const ListingOneImg = ({ data }) => {
    return (
        <div className="col-4 mb20">
            <img src={data.image[0]} className="mantra_img_card" />
        </div>
    )
}
export default ListingOneImg;